<template>
    <div class="row mt-2"><div class="col d-flex">

        <font-awesome-icon class="fa-pulse spinner" icon="spinner" size="2x" /><span class="mt-1 ml-2 font-italic">Loading data...</span></div></div>

</template>

<script>
    export default {
        name: "SmallSpinner"
    }
</script>

<style scoped>
    .loading-container {

    }

</style>